import { render, staticRenderFns } from "./adminPickCollTemplate.vue?vue&type=template&id=232dccad"
import script from "./adminPickCollTemplate.vue?vue&type=script&lang=js"
export * from "./adminPickCollTemplate.vue?vue&type=script&lang=js"
import style0 from "./adminPickCollTemplate.vue?vue&type=style&index=0&id=232dccad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports